import { render, staticRenderFns } from "./animated-amount.vue?vue&type=template&id=efe8563c"
import script from "./animated-amount.vue?vue&type=script&lang=js"
export * from "./animated-amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe8563c')) {
      api.createRecord('efe8563c', component.options)
    } else {
      api.reload('efe8563c', component.options)
    }
    module.hot.accept("./animated-amount.vue?vue&type=template&id=efe8563c", function () {
      api.rerender('efe8563c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/animated-amount.vue"
export default component.exports